/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Quote_5_WhoInputs */

const da_forside_quote_5_who = /** @type {(inputs: Forside_Quote_5_WhoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afdelingsleder, udskoling`)
};

/** @type {(inputs: Forside_Quote_5_WhoInputs) => LocalizedString} */
const en_forside_quote_5_who = da_forside_quote_5_who;

/**

* @param {Forside_Quote_5_WhoInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_quote_5_who = /** @type {((inputs?: Forside_Quote_5_WhoInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Quote_5_WhoInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_quote_5_who(inputs)
	return /** @type {LocalizedString} */ ("Afdelingsleder, udskoling")
});